import { SVGProps, useId } from "react";

export default function PostPresentationResourcesIcon(
  props: SVGProps<SVGSVGElement>,
) {
  const { height = 20, width = 20, ...rest } = props;
  const id = useId();
  const leftGradientId = `post_presentation_resources_left_${id}`;
  const rightGradientId = `post_presentation_resources_right_${id}`;
  const centerGradientId = `post_presentation_resources_center_${id}`;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M6.04223 10.0003C6.04223 9.65866 6.32556 9.37533 6.66723 9.37533H9.16723V6.25033C9.16723 5.79199 8.79223 5.41699 8.3339 5.41699H6.47556C3.85056 5.41699 1.56723 7.56699 1.66723 10.1837C1.71723 11.3753 2.21723 12.4503 3.0089 13.242C3.84223 14.067 4.98389 14.5837 6.25056 14.5837H8.3339C8.79223 14.5837 9.16723 14.2087 9.16723 13.7503V10.6253H6.66723C6.32556 10.6253 6.04223 10.342 6.04223 10.0003Z"
        fill={`url(#${leftGradientId})`}
      />
      <path
        d="M16.9943 6.75866C16.1609 5.93366 15.0193 5.41699 13.7526 5.41699H11.6693C11.2109 5.41699 10.8359 5.79199 10.8359 6.25033V9.37533H13.3359C13.6776 9.37533 13.9609 9.65866 13.9609 10.0003C13.9609 10.342 13.6776 10.6253 13.3359 10.6253H10.8359V13.7503C10.8359 14.2087 11.2109 14.5837 11.6693 14.5837H13.5276C16.1526 14.5837 18.4359 12.4337 18.3276 9.81699C18.2859 8.62533 17.7776 7.55033 16.9943 6.75866Z"
        fill={`url(#${rightGradientId})`}
      />
      <path
        d="M10.8307 9.375H9.16406V10.625H10.8307V9.375Z"
        fill={`url(#${centerGradientId})`}
      />
      <defs>
        <linearGradient
          id={leftGradientId}
          x1="5.41565"
          y1="5.41699"
          x2="5.41565"
          y2="14.5837"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={rightGradientId}
          x1="14.5836"
          y1="5.41699"
          x2="14.5836"
          y2="14.5837"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={centerGradientId}
          x1="9.9974"
          y1="9.375"
          x2="9.9974"
          y2="10.625"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
      </defs>
    </svg>
  );
}
